class SearchBar {
	static SELECTOR_ID_SEARCH_INPUT = '#s'
	static SELECTOR_ID_SEARCH_CONTAINER = '#jsSearchContainer'
	static SELECTOR_ID_SEARCH_FORM = '#jsSearchForm'
	static SELECTOR_ID_NAV_MENU = '#navList'

	static CLASS_NAME_MOBILE_VIEW = 'navigation__search--mobile-view'

	static ATTR_REQUIRED = 'required'

	static BREAKPOINT_WIDTH = 975

	constructor() {
		this.searchContainer = null
		this.searchForm = null
		this.navMenu = null
		this.docWidth = 0
		this.searchInputField = null

		document.addEventListener( 'DOMContentLoaded', () => {
			this.init()
		} )
	}

	init() {
		this.searchInputField = document.querySelector( SearchBar.SELECTOR_ID_SEARCH_INPUT )

		if ( this.searchInputField ) {
			this.searchInputField.setAttribute( SearchBar.ATTR_REQUIRED, SearchBar.ATTR_REQUIRED )
		}

		this.defineAndRefreshHooks()

		const searchForm = document.querySelector( SearchBar.SELECTOR_ID_SEARCH_FORM )
		if ( searchForm ) {
			searchForm.style.visibility = 'visible'
			this.moveSearchSection( this.docWidth )

			window.addEventListener( 'resize', () => {
				this.defineAndRefreshHooks()
				this.moveSearchSection( this.docWidth )
			} )
		}
	}

	defineAndRefreshHooks() {
		this.searchContainer = document.querySelector( SearchBar.SELECTOR_ID_SEARCH_CONTAINER )
		this.searchForm = document.querySelector( SearchBar.SELECTOR_ID_SEARCH_FORM )
		this.navMenu = document.querySelector( SearchBar.SELECTOR_ID_NAV_MENU )
		this.docWidth = document.documentElement.clientWidth
	}

	moveSearchSection( width ) {
		if ( this.searchInputField && document.activeElement === this.searchInputField ) {
			return
		}

		if ( width < SearchBar.BREAKPOINT_WIDTH ) {
			if ( this.searchForm && this.navMenu && this.navMenu.parentElement ) {
				this.searchForm.classList.add( SearchBar.CLASS_NAME_MOBILE_VIEW )
				this.navMenu.parentElement.appendChild( this.searchForm )
			}
		} else {
			if ( this.searchForm && this.searchContainer ) {
				this.searchForm.classList.remove( SearchBar.CLASS_NAME_MOBILE_VIEW )
				this.searchContainer.appendChild( this.searchForm )
			}
		}
	}
}

new SearchBar()
